import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const CaretUpIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path d="M12 10.8L7.4 15.4L6 14L12 8L18 14L16.6 15.4L12 10.8Z" />
  </Icon>
)
